(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cases"] && !Shopify.designMode) return;
  try {
    
  class CasesSection extends HTMLElement {
    connectedCallback() {
      this.waitForGSAP();
    }

    waitForGSAP() {
      if (window.gsap) {
        this.init();
      } else {
        const check = setInterval(() => {
          if (window.gsap) {
            clearInterval(check);
            this.init();
          }
        }, 50);
        setTimeout(() => clearInterval(check), 5000);
      }
    }

    init() {
      gsap.registerPlugin(ScrollTrigger);

      requestAnimationFrame(() => {
        const isMobile = window.innerWidth < 768;
        const isDesignMode = window.Shopify?.designMode;

        const images = this.querySelectorAll('.environment-card__image, .screenshot-card__image');

        images.forEach((image, index) => {
          const card = image.closest('.environment-card, .screenshot-card');

          if (isMobile || isDesignMode) {
            gsap.set(image, { scale: 1, opacity: 1 });
            card?.classList.add('is-revealed');
            return;
          }

          gsap.set(image, {
            scale: 0.75,
            opacity: 0,
            transformOrigin: 'center center'
          });

          gsap.to(image, {
            scale: 1,
            opacity: 1,
            duration: 1.2,
            ease: 'expo.out',
            delay: index * 0.1,
            scrollTrigger: {
              trigger: image,
              start: 'top 85%',
              toggleActions: 'play none none none',
              once: true
            },
            onComplete: () => {
              card?.classList.add('is-revealed');
            }
          });
        });
      });
    }
  }

  customElements.define('cases-section', CasesSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-showcase"] && !Shopify.designMode) return;
  try {
    
  class FeatureShowcase extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('feature-showcase--cinematic')) return;

      this.track = this.querySelector('[data-track]');
      this.count = this.querySelector('[data-count]');
      this.total = Number(this.dataset.featureCount);
      this.motion = window.matchMedia('(prefers-reduced-motion: no-preference) and (min-height: 700px)');
      this.frame = 0;

      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => this.update());
      };

      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule);
      this.motion.addEventListener('change', this.schedule);
      this.update();

      // The track clips its cards, so lazy images would only start loading as they slide in.
      this.imageLoader = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) return;

          this.imageLoader.disconnect();
          this.querySelectorAll('img').forEach((image) => {
            image.loading = 'eager';
          });
        },
        { rootMargin: '100% 0px' }
      );
      this.imageLoader.observe(this);
    }

    disconnectedCallback() {
      if (!this.schedule) return;

      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      this.motion.removeEventListener('change', this.schedule);
      this.imageLoader.disconnect();
      cancelAnimationFrame(this.frame);
    }

    update() {
      this.frame = 0;

      if (!this.motion.matches) {
        this.track.style.transform = '';
        return;
      }

      const pinned = this.track.parentElement;
      const scrollable = this.offsetHeight - pinned.offsetHeight;
      const progress = scrollable > 0 ? Math.min(1, Math.max(0, -this.getBoundingClientRect().top / scrollable)) : 0;
      const eased = progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
      const lastCard = this.track.lastElementChild;
      const trackEnd = lastCard.offsetLeft + lastCard.offsetWidth + parseFloat(getComputedStyle(this.track).paddingRight);
      const distance = Math.max(0, trackEnd - pinned.clientWidth);

      this.track.style.transform = `translateX(${-distance * eased}px)`;
      this.count.textContent = `${Math.min(this.total, 1 + Math.floor(progress * this.total))} / ${this.total}`;
    }
  }

  customElements.define('feature-showcase', FeatureShowcase);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LoadingAnkonLogo extends HTMLElement {
    connectedCallback() {
      // Wait for dotlottie-wc custom element to be defined
      const waitForDotLottie = () => {
        if (customElements.get('dotlottie-wc')) {
          this.init();
        } else {
          setTimeout(waitForDotLottie, 50);
        }
      };
      waitForDotLottie();
    }

    init() {
      this.dotlottieWc = this.querySelector('dotlottie-wc');
      if (!this.dotlottieWc) {
        setTimeout(() => this.init(), 100);
        return;
      }

      const playAnimation = () => {
        const instance = this.dotlottieWc.dotLottie;
        if (instance && typeof instance.play === 'function') {
          instance.play();
        } else if (typeof this.dotlottieWc.play === 'function') {
          this.dotlottieWc.play();
        } else {
          this.dotlottieWc.setAttribute('autoplay', 'true');
          setTimeout(() => this.dotlottieWc.removeAttribute('autoplay'), 100);
        }
      };

      const setup = () => {
        if (this.setupComplete) return;
        
        const instance = this.dotlottieWc.dotLottie;
        if (!instance) {
          this.dotlottieWc.addEventListener('ready', () => {
            setTimeout(setup, 100);
          }, { once: true });
          setTimeout(() => {
            if (!this.setupComplete && this.dotlottieWc.dotLottie) setup();
          }, 1000);
          return;
        }

        this.setupComplete = true;

        // Check if already in view
        const rect = this.getBoundingClientRect();
        const isInView = rect.top < window.innerHeight && rect.bottom > 0;

        if (isInView) {
          this.hasPlayed = true;
          setTimeout(playAnimation, 200);
        } else {
          // Play once when scrolled into view
          const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && !this.hasPlayed) {
              this.hasPlayed = true;
              playAnimation();
              observer.disconnect();
            }
          }, { threshold: 0.1 });
          observer.observe(this);
        }

        // Loop on hover
        this.addEventListener('mouseenter', () => {
          if (instance && typeof instance.setLoop === 'function') {
            instance.setLoop(true);
          } else {
            this.dotlottieWc.setAttribute('loop', 'true');
          }
          playAnimation();
        });

        this.addEventListener('mouseleave', () => {
          if (instance && typeof instance.setLoop === 'function') {
            instance.setLoop(false);
          } else {
            this.dotlottieWc.setAttribute('loop', 'false');
          }
        });
      };

      setup();
    }
  }

  customElements.define('loading-ankon-logo', LoadingAnkonLogo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a.header__menu-item, a[data-hash-link]');
    if (!link) return;
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin) return;
    if (url.pathname !== window.location.pathname) return;
    if (!url.hash || url.hash === '#') return;

    const target = document.querySelector(url.hash);
    if (!target) return;

    event.preventDefault();
    // The scroll lock must be released before scrolling, otherwise the page is pinned at its old offset.
    const openDrawers = document.querySelectorAll('.drawer--open');
    openDrawers.forEach((drawer) => drawer.close());
    target.scrollIntoView({ behavior: openDrawers.length ? 'auto' : 'smooth', block: 'start' });
    history.pushState(null, '', url.hash);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-reveal"] && !Shopify.designMode) return;
  try {
    
  class MediaReveal extends HTMLElement {
    connectedCallback() {
      this.playVideoNearViewport();
      this.waitForGSAP();
    }

    disconnectedCallback() {
      this.videoObserver?.disconnect();
      this.trigger?.kill();
      clearInterval(this.gsapCheck);
      clearTimeout(this.gsapTimeout);
    }

    /* Autoplay would make the browser download the whole video on load, however far down the page it is. */
    playVideoNearViewport() {
      const video = this.querySelector('video');
      if (!video || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.videoObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        },
        { rootMargin: '200px 0px' }
      );
      this.videoObserver.observe(this);
    }

    waitForGSAP() {
      if (window.gsap && window.ScrollTrigger) {
        this.init();
        return;
      }

      this.gsapCheck = setInterval(() => {
        if (window.gsap && window.ScrollTrigger) {
          clearInterval(this.gsapCheck);
          clearTimeout(this.gsapTimeout);
          this.init();
        }
      }, 50);

      // Without GSAP the columns would cover the media for good.
      this.gsapTimeout = setTimeout(() => {
        clearInterval(this.gsapCheck);
        this.querySelector('.media-reveal__overlays')?.remove();
      }, 5000);
    }

    init() {
      gsap.registerPlugin(ScrollTrigger);

      const isMobile = window.innerWidth < 768;
      const isDesignMode = window.Shopify?.designMode;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const animationType = this.dataset.animation || 'grid';

      const overlays = this.querySelectorAll('.media-reveal__overlay');
      const media = this.querySelector('.media-reveal__video, .media-reveal__image, .media-reveal__placeholder');

      if (isMobile || isDesignMode || prefersReducedMotion) {
        if (overlays.length) gsap.set(overlays, { scaleX: 0 });
        return;
      }

      let timeline;

      if (animationType === 'scale') {
        gsap.set(media, { scale: 0.75, transformOrigin: 'center center' });
        timeline = gsap.timeline({ paused: true }).to(media, {
          scale: 1,
          duration: 1.2,
          ease: 'power2.out'
        });
      } else {
        // Reversed for a right-to-left reveal.
        timeline = gsap.timeline({ paused: true }).to([...overlays].reverse(), {
          scaleX: 0,
          duration: 0.5,
          ease: 'power4.inOut',
          stagger: 0.025
        });
      }

      this.trigger = ScrollTrigger.create({
        trigger: this,
        start: 'top 90%',
        once: true,
        onEnter: () => timeline.play()
      });
    }
  }

  customElements.define('media-reveal', MediaReveal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats"] && !Shopify.designMode) return;
  try {
    
  class StatsCounters extends HTMLElement {
    connectedCallback() {
      const els = this.querySelectorAll('[data-count-target]');
      if (els.length === 0) return;

      const isMobile = window.innerWidth < 768;
      const isDesignMode = window.Shopify && window.Shopify.designMode;
      if (isMobile || isDesignMode) return;

      els.forEach((el) => (el.textContent = '0'));

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.animate(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.3 }
      );

      els.forEach((el) => observer.observe(el));
    }

    animate(el) {
      const target = parseInt(el.dataset.countTarget, 10);
      if (isNaN(target)) return;

      const duration = 1500;
      const start = performance.now();

      const tick = (now) => {
        const elapsed = now - start;
        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.floor(target * eased);
        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          el.textContent = target;
        }
      };

      requestAnimationFrame(tick);
    }
  }

  customElements.define('stats-counters', StatsCounters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class TestimonialCard extends HTMLElement {
    connectedCallback() {
      this.review = this.querySelector('[data-review]');
      this.toggle = this.querySelector('[data-toggle]');
      if (!this.review || !this.toggle) return;

      this.toggle.addEventListener('click', () => this.setExpanded(this.toggle.getAttribute('aria-expanded') !== 'true'));

      // Measure after fonts load, otherwise line wrapping (and so the overflow check) is off.
      document.fonts.ready.then(() => this.measure());
    }

    measure() {
      this.setAttribute('data-clamped', '');
      const overflows = this.review.scrollHeight > this.review.clientHeight + 1;
      if (!overflows) this.removeAttribute('data-clamped');
      this.toggle.hidden = !overflows;
    }

    setExpanded(expanded) {
      this.toggleAttribute('data-clamped', !expanded);
      this.toggle.setAttribute('aria-expanded', String(expanded));
      this.toggle.querySelector('[data-more]').hidden = expanded;
      this.toggle.querySelector('[data-less]').hidden = !expanded;
    }
  }

  class TestimonialCarousel extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-testimonial-list]');
      this.controls = this.querySelector('[data-controls]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.list || !this.controls) return;

      this.prev.addEventListener('click', () => this.scrollByCard(-1));
      this.next.addEventListener('click', () => this.scrollByCard(1));
      this.list.addEventListener('scroll', () => this.updateControls(), { passive: true });

      this.resizeObserver = new ResizeObserver(() => this.layout());
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(document.documentElement);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    layout() {
      const rect = this.getBoundingClientRect();
      this.style.setProperty('--bleed-left', `${Math.max(rect.left, 0)}px`);
      this.style.setProperty('--bleed-right', `${Math.max(document.documentElement.clientWidth - rect.right, 0)}px`);
      this.updateControls();
    }

    scrollByCard(direction) {
      const card = this.list.firstElementChild;
      const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
      this.list.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
    }

    updateControls() {
      const maxScroll = this.list.scrollWidth - this.list.clientWidth;
      this.controls.hidden = maxScroll <= 1;
      this.prev.disabled = this.list.scrollLeft <= 1;
      this.next.disabled = this.list.scrollLeft >= maxScroll - 1;
    }
  }

  if (!customElements.get('testimonial-card')) customElements.define('testimonial-card', TestimonialCard);
  if (!customElements.get('testimonial-carousel')) customElements.define('testimonial-carousel', TestimonialCarousel);

  } catch(e) { console.error(e); }
})();
})();
